import { cn } from "../../../Utils/helper";

const Breadcrumb = ({
  breadCrumbTiltle,
  onClickBack,
  className,
  classNameText,
  imagesSubTitle,
  classNameTitle,
  disabledBack = false,
}) => {
  return (
    <div
      className={cn(
        `flex flex-col items-start gap-6 ${
          classNameText ? classNameText : "text-[#253FF6]"
        }   font-bold`,
        className
      )}
    >
      <div className="w-[42px] h-[42px] rounded-full">
        <div onClick={disabledBack ? undefined : onClickBack} className="w-full h-full flex items-center justify-center">
          <span
            className={cn(
              "cursor-pointer icon icon-arrow-left text-[18px] text-mid-gray",
              disabledBack && "hidden"
            )}
          />
        </div>
      </div>

      <div className="flex flex-row items-center gap-2">
        {imagesSubTitle && <img src={imagesSubTitle} alt="" className="w-5 h-5 object-cover" />}
        <h4
          className={cn(
            "text-[#253FF6] font-[Figtree] text-[22px] xs:text-[32px] font-bold not-italic leading-none",
            classNameTitle
          )}
        >
          {breadCrumbTiltle}
        </h4>
      </div>
    </div>
  );
};

export default Breadcrumb;
